// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type FastTimer20CircleFilledProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const FastTimer20CircleFilled: FC<FastTimer20CircleFilledProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="24"
            height="24"
        >
            <path d="m17.52 13.73-1.062 1.062L14 12.318V9h1.498v2.702l2.023 2.027Z" />
            <path
                d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Zm-1.5-7.75c1.167 1.167 2.583 1.75 4.249 1.75 1.653 0 3.067-.583 4.24-1.75 1.174-1.167 1.761-2.583 1.761-4.249 0-1.653-.587-3.067-1.76-4.24C17.816 6.586 16.402 6 14.749 6c-1.666 0-3.082.587-4.249 1.76-1.167 1.174-1.75 2.588-1.75 4.241 0 1.666.583 3.082 1.75 4.249ZM4.5 8v1.5h3V8h-3Zm3 3.25h-4v1.5h4v-1.5Zm-3 3.25V16h3v-1.5h-3Z"
                fillRule="evenodd"
                clipRule="evenodd"
            />
        </svg>
    );
};

export default FastTimer20CircleFilled;
